import * as React from 'react';
import { Colorways } from 'types/constants';
import { cn, getColorway } from 'utils/styles';
import { CardEyebrow } from './CardEyebrow';
import { CardHeadline } from './CardHeadline';
import { CardContent } from './CardContent';
import { CardsExpandableItemProps } from './types';
import Media from '@/components/shared/Media/Media';

const CardsExpandableItemDesktop = ({ item, parentId, position }: CardsExpandableItemProps) => {
  const { sys, eyebrow, cardCopy, cardHeadline, cardImage, cardListItems, aspectRatio } = item;
  const cardId = `card-${sys?.id}`;
  const headlineId = `headline-${parentId}-${position}`;
  const contentId = `content-${sys?.id}`;
  const { items: listItems } = cardListItems;
  const colorway = getColorway(Colorways.Inverse);

  // In this desktop version, the card background is implemented in the various divs themselves rather than a wrapping div
  // This is because the parent needs to be a grid to control the relative heights of the items between cards to keep things aligned
  return (
    <>
      <div className={cn('px-10 pt-12 pb-6 rounded-t-lg', colorway)}>
        <CardEyebrow eyebrow={eyebrow} cardId={cardId} />
      </div>
      <div className={cn('px-10 pb-4', colorway)}>
        <CardHeadline cardHeadline={cardHeadline} cardId={cardId} headlineId={headlineId} />
      </div>
      <div className={cn('px-10', colorway)}>
        {cardImage && (
          <Media
            media={cardImage}
            className="m-auto w-full mb-8"
            sizes="(max-width: 1440px) 50vw, 600px"
            aspectRatio={aspectRatio}
          />
        )}
      </div>
      <div className={cn('px-10', colorway)}>
        <div className="w-full border-t border-(--keyline-color) hidden sm:block" />
      </div>
      <div className={cn('px-10 pt-6 pb-10 rounded-b-lg', colorway)}>
        <div id={contentId} className="flex flex-col gap-5">
          <CardContent cardCopy={cardCopy} listItems={listItems} isContentHidden={false} />
        </div>
      </div>
    </>
  );
};

export default CardsExpandableItemDesktop;
